import { useState } from 'react'
import { PlaneShare, PreviewArrowRight, Trash } from '../../../../assets/svgs/icons'
import styles from './styles.module.css'
import { object } from 'prop-types'

export const LayoutTikTok = ({
  image,
  legend,
  userData,
  setValueItem,
  type,
  selectedValues,
  setImageUrl,
  setTiktokMusic,
  setTiktokMusicCheckbox,
  removeImage
}) => {
  const [showButtons, setShowButtons] = useState(false)

  function nextImage(type) {
    if (type === 4) {
      setValueItem(1)
    } else {
      setValueItem(type + 1)
    }
  }

  function previewImage(type) {
    if (type === 1) {
      setValueItem(4)
    } else {
      setValueItem(type - 1)
    }
  }
  return (
    <div className={styles.box_image_render}>
      <p className={styles.previewText}>TikTok</p>
      <div className={styles.body_image_render}>
        <div
          className={styles.carouselContainer}
          onMouseEnter={() => setShowButtons(true)}
          onMouseLeave={() => setShowButtons(false)}
        >
          <button
            className={styles.carouselButtonLeft}
            onClick={() => nextImage(type)}
            style={{
              opacity: showButtons ? 1 : 0,
              transition: 'opacity 0.3s',
              transform: 'rotate(180deg)',
            }}
          >
            <div 
              style={{display: 'flex',
                background: '#000',
                borderRadius: '5px',
                marginBottom: -28}}>
              <PreviewArrowRight />
            </div>
          </button>
          <img src={image} className={`${styles.carouselImage} ${removeImage ? styles.blur_image: ''}`} alt="Imagem" />
          {removeImage && (

            <div className={styles.box_button_delete_image}>
              <button
                onClick={() => {
                  setImageUrl()
                  setTiktokMusic()
                  setTiktokMusicCheckbox()
                }}
                className={styles.button_delete_image}
                style={{
                  opacity: showButtons ? 1 : 0,
                  transition: 'opacity 0.3s',
                }}
              >
                <Trash width={25} height={25} color={"#000000"}/>
              </button>
            </div>
          )}
          <button
            className={styles.carouselButtonRight}
            onClick={() => previewImage(type)}
            style={{
              opacity: showButtons ? 1 : 0,
              transition: 'opacity 0.3s',
            }}
          >
            <div style={{display: 'flex',
                background: '#000',
                borderRadius: '5px'}}>
              <PreviewArrowRight />
            </div>
          </button>
        </div>
      </div>

      <div className={styles.footer_image_render}>
        <div className={styles.box_icons}>
          <div>
            {/* <HeartLike />
            <PlaneShare /> */}
            {/* <CommentBubble />
            <PlaneShare /> */}
          </div>
          <div>
            {/* <HeartLike /> */}
            <PlaneShare />
            {/* <SaveFlag /> */}
          </div>
        </div>
        <p className={styles.legend_publication}>
          {/* {truncateString(legend, 60)} */}
        </p>
      </div>
    </div>
  )
}

LayoutTikTok.propTypes = {
  image: object,
}
